import { Adjust, Elevator, Pentagon, Stairs } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function ShapeToolPalette(props) {

	return (<div className="bd-area-selector-toggle">
		<h3>Features</h3>
		<IconButton 
			onClick={ props.onAddPolygonClick }
			className="bd-tool-button" title="Add a polygon">
			<Pentagon />
		</IconButton>

		<IconButton className="bd-tool-button" title="Add a generic node"
			onClick={ props.onAddNodeClick } >
			<Adjust />
		</IconButton>

		<IconButton className="bd-tool-button" title="Add an elevator node"
			onClick={ props.onAddElevatorClick } >
			<Elevator />
		</IconButton>

		<IconButton className="bd-tool-button" title="Add stairs"
			onClick={ props.onAddStairsClick }>
			<Stairs />
		</IconButton>
	</div>);
}

export default ShapeToolPalette;